module.exports = __webpack_public_path__ + "img/Inflammation-BRCA_10X_Section1.68caf598.png";